import axios from "axios";
import { APIHost } from "./helpers";

// Base URL
export const baseURL = () => {
  return APIHost() + ":3107/consumer/market_refund";
};

// Refund Order
export const mallRefundOrder = (id, params) => {
  const url = `${baseURL()}/requestRefund/${id}`;

  return axios.post(url, params);
};

// Withdraw Refund
export const mallWithdrawRefund = id => {
  const url = `${baseURL()}/cancelRequestRefund/${id}`;

  return axios.get(url);
};
